import { ofType, StateObservable } from 'redux-observable';
import { mergeMap, Observable } from 'rxjs';
import { IshState } from 'src/js/services/IshState';
import { getCheckoutModelFromBackend, UPDATE_PAYNOW } from '../../../actions/Actions';
import { Phase } from '../../../reducers/State';
import { Tabs } from '../reducers/State';

function createValidatePaymentEpic() {
  return (action$: Observable<any>, store: StateObservable<IshState>) => action$.pipe(
    ofType(
      UPDATE_PAYNOW
    ),
    mergeMap(() => {
      const state = store.value;
      const isCCPayment = state.checkout.page === Phase.Payment
        && state.checkout.payment.currentTab === Tabs.creditCard;
      return isCCPayment ? [getCheckoutModelFromBackend()] : [];
    })
  );
}

export const EpicValidatePayment = createValidatePaymentEpic();
